// src/components/sinister/ModalUpdateProperty.tsx

import { Modal, Box, Grid, Typography, Button, MenuItem, LinearProgress, Icon, Paper } from "@mui/material";
import { FormHandles } from "@unform/core";
import { VForm, VTextField } from "../../../../shared/forms";
import { useEffect, useRef, useState } from "react";

interface ModalUpdatePropertyProps {
	open: boolean;
	isLoading: boolean;
	isUploading: boolean;
	handleSubmit: (data: any) => void;
	initialBusyProperty?: string;
	isClose: () => void;
}

export default function ModalUpdateProperty({ open, isLoading, isUploading, handleSubmit, initialBusyProperty, isClose }: ModalUpdatePropertyProps) {
	const formRef = useRef<FormHandles>(null);
	const [formKey, setFormKey] = useState(0);
	const [initialFormData, setInitialFormData] = useState({});

	useEffect(() => {
		if (open) {
			setFormKey((prevKey) => prevKey + 1);
			setInitialFormData({ busyProperty: initialBusyProperty });
			setTimeout(() => {
				formRef.current?.setErrors({});
			}, 0);
		} else {
			setInitialFormData({});
		}
	}, [open, initialBusyProperty]);

	const internalHandleSubmit = (data: { busyProperty?: string }) => {
		if (!data.busyProperty) {
			formRef.current?.setErrors({ busyProperty: "Selecione uma situação" });
			return;
		}
		handleSubmit(data);
	};

	return (
		<Modal open={open} onClose={isClose} disableEnforceFocus>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "45%",
					outline: "none",
				}}
			>
				<Paper sx={{ p: 4 }}>
					<Typography variant="h5" fontWeight={300} mb={2} color="primary" textAlign="center">
						Alteração de situação do imóvel em sinistro
					</Typography>

					<VForm
						key={formKey}
						id="formIdUpdatePropertySave"
						ref={formRef}
						onSubmit={internalHandleSubmit}
						initialData={initialFormData} // Passe os dados iniciais aqui
						placeholder="Digite aqui..."
						onPointerEnterCapture={() => {}}
						onPointerLeaveCapture={() => {}}
					>
						<Grid container direction="column" spacing={2}>
							{isLoading && (
								<Grid item>
									<LinearProgress />
								</Grid>
							)}

							<Grid item>
								<Typography>A alteração do status poderá ter a obrigação de anexo de novos documentos para continuar o sinistro.</Typography>
							</Grid>

							<Grid container item spacing={2}>
								<Grid item xs={12} md={6}>
									<VTextField fullWidth label="Situação do imóvel" name="busyProperty" defaultValue={initialBusyProperty} select required>
										<MenuItem value="busy">Ocupado</MenuItem>
										<MenuItem value="not_busy">Desocupado</MenuItem>
									</VTextField>
								</Grid>
							</Grid>

							<Grid container item justifyContent="center" spacing={2} mt={2}>
								<Grid item gap={2} display="flex" justifyContent="center" alignItems="center">
									<Button
										variant="contained"
										color="inherit"
										startIcon={<Icon>arrow_back</Icon>}
										onClick={isClose}
										sx={{ width: "160px" }}
									>
										Voltar
									</Button>

									<Button
										variant="contained"
										startIcon={<Icon>check</Icon>}
										onClick={() => formRef.current?.submitForm()}
										disabled={isUploading}
										sx={{ width: "160px" }}
									>
										Confirmar
									</Button>
								</Grid>
							</Grid>
						</Grid>
					</VForm>
				</Paper>
			</Box>
		</Modal>
	);
}
